// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","errorContainer":"editShippingAddressWrapper_errorContainer__mgwD_","retryButton":"editShippingAddressWrapper_retryButton__jp5XN"};